import { normalizeSubjectCode } from './dseSubjects';

/** Compulsory HKDSE subjects required before programme selection. */
export const DSE_COMPULSORY_SUBJECT_CODES = ['ENG', 'CHI', 'MAT', 'CSD'];

const COMPULSORY_SET = new Set(DSE_COMPULSORY_SUBJECT_CODES);

/**
 * @param {{ subjectCode?: string, score?: string, isCompulsory?: boolean, isCore?: boolean }[]} rows
 * Completed rows only (subjectCode + score) are expected from the parent; full rows from DSEScoreInputer also work.
 */
export function analyzeDseScoreCompleteness(rows = []) {
  const completed = (rows || [])
    .filter((row) => row?.subjectCode && row?.score)
    .map((row) => ({
      ...row,
      subjectCode: normalizeSubjectCode(row.subjectCode),
    }));
  const byCode = new Map(completed.map((row) => [row.subjectCode, row]));

  const missingCompulsory = DSE_COMPULSORY_SUBJECT_CODES.filter((code) => !byCode.has(code));
  const electives = completed.filter((row) => {
    if (COMPULSORY_SET.has(row.subjectCode)) return false;
    if (row.isCompulsory || row.isCore) return false;
    return true;
  });
  const hasElective = electives.length > 0;
  const isComplete = missingCompulsory.length === 0 && hasElective;

  return {
    isComplete,
    missingCompulsory,
    hasElective,
    electiveCount: electives.length,
    completed,
    byCode,
  };
}

export function isDseScoreSetComplete(rows) {
  return analyzeDseScoreCompleteness(rows).isComplete;
}
